import { useState } from 'react';
import { PhoneNumberUtil } from 'google-libphonenumber';

interface PhoneValidatorProps {
  onInvalid?: string;
}

export const usePhoneValidator = ({ onInvalid }: PhoneValidatorProps) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const [isValid, setIsValid] = useState<boolean | null>(null);

  const validatePhone = (phoneNumber: string) => {
    try {
      const region = phoneUtil.getRegionCodeForNumber(phoneUtil.parse(phoneNumber));
      const number = phoneUtil.parse(phoneNumber, region);
      const valid = phoneUtil.isValidNumberForRegion(number, region);
      setIsValid(valid);
      if (!valid) {
        return onInvalid;
      }
    } catch (error) {
      setIsValid(false);
      return onInvalid;
    }
    return '';
  };
  return {
    isValid,
    validatePhone,
  };
};
